export default "__VITE_ASSET__1A_r7MYn__"